import React, { useLayoutEffect, useState, useContext } from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';

import * as S from './styles';
import { color } from 'styles/pallete';
import { DataForm, Link } from 'types/InputVerticalRedirectLinkProps';
import SelectInput from 'components/SelectInput';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { optionsTypeVerticalRedirectableLink } from 'utils/optionsInputs';
import AddBtn from 'components/AddBtn';
import FormAddVerticalRedirectableLink from 'components/FormAddVerticalRedirectableLink';
import { returListOptionsDynamicPage, verifyIfFormCanSave } from './functions';
import DynamicPageContext from 'context/DynamicPage';
import { png } from 'utils/imgList';

const initialDate: DataForm = {
	type: '',
	links: []
};

export default function InputsVerticalRedirectableLinks() {
	const {
		dynamicPagesList,
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] = useState(initialDate);
	const [isOpenFormLink, setIsOpenFormLink] = useState(false);
	const [linkToEdit, setLinkToEdit] = useState<Link | null>(null);
	const [optionsDynamicScreen, setOptionsDynamicScreen] = useState<
		SelectInputItemProps[]
	>([]);

	function findOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	function addNewBanner(newLink: Link) {
		setDataForm((obj) => ({ ...obj, links: [...obj.links, newLink] }));
		setIsOpenFormLink(false);
	}

	function editBanner(linkEdited: Link) {
		const newList = dataForm.links.map((item) => {
			if (item.idFront === linkToEdit?.idFront) {
				return { ...item, ...linkEdited };
			}

			return item;
		});
		setDataForm((obj) => ({ ...obj, links: newList }));
		setIsOpenFormLink(false);
		setLinkToEdit(null);
	}

	function deleteLinkFromList(id: string) {
		const newList = dataForm.links.filter((item) => item.idFront !== id);
		setDataForm((obj) => ({ ...obj, links: newList }));
	}

	function returnNameRedirectByIdDynamicScreen(id: string) {
		const item = optionsDynamicScreen.filter((item) => item.id === id);
		return item.length > 0 ? item[0].option : 'Não encontrado';
	}

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);
		}
	}, []);

	//cria lista de opções de pagínas dinamicas em um estado para evitar reenderização
	useLayoutEffect(() => {
		setOptionsDynamicScreen(returListOptionsDynamicPage(dynamicPagesList));
	}, []);

	return (
		<S.container>
			<SelectInput
				list={optionsTypeVerticalRedirectableLink}
				getValue={(value: SelectInputItemProps | '') => {
					setDataForm((obj) => ({
						...obj,
						type: value === '' ? value : (value?.id as string)
					}));
				}}
				initialValue={
					dataForm.type === ''
						? optionsTypeVerticalRedirectableLink[0]
						: findOptionOnListById(
								dataForm.type || '',
								optionsTypeVerticalRedirectableLink
							)
				}
				label="Tipo"
			/>
			<AddBtn
				text="Adicionar link"
				anyFunction={() => setIsOpenFormLink(true)}
			/>
			<S.listLinks>
				{dataForm.links.length > 0 ? (
					dataForm.links.map((item) => (
						<S.link key={item.idFront}>
							<img
								src={`${item.image.path === '' ? png.genericImage : item.image.path}`}
							/>

							<S.content>
								<p>
									<b>Nome: </b>
									{item.name}
								</p>
								<p>
									<b>Tipo de redirecionamento: </b>
									{item.redirect.type}
								</p>
								<p>
									<b>Valor: </b>
									{item.redirect.type === 'app_screen'
										? returnNameRedirectByIdDynamicScreen(item.redirect.value)
										: item.redirect.value}
								</p>
								<S.contentColor>
									<b>Cor do texto: </b>
									<S.ballColor $color={item.text_color} />
								</S.contentColor>
							</S.content>

							<S.actions>
								<MdDelete
									onClick={() => deleteLinkFromList(item.idFront)}
									color={color.system.error}
								/>
								<MdEdit
									onClick={() => {
										setIsOpenFormLink(true);
										setLinkToEdit(item);
									}}
									color={color.interface.darkgray3}
								/>
							</S.actions>
						</S.link>
					))
				) : (
					<S.noBanner>
						<p>Não há links cadastrado</p>
					</S.noBanner>
				)}
			</S.listLinks>

			{isOpenFormLink && (
				<FormAddVerticalRedirectableLink
					isOpen={isOpenFormLink}
					setIsOpen={(value) => {
						setIsOpenFormLink(value);
						setLinkToEdit(null);
					}}
					functionToGetDataAboutLink={
						linkToEdit === null ? addNewBanner : editBanner
					}
					linkToEdit={linkToEdit}
					optionsDynamicScreen={optionsDynamicScreen}
				/>
			)}
		</S.container>
	);
}
